
import Vue from 'vue'
import {
  VBtn,
  VCard,
  VContainer,
  VDialog,
  VIcon,
  VSpacer,
  VToolbar,
  VToolbarItems,
  VToolbarTitle,
} from 'vuetify/lib'
export default Vue.extend({
  name: 'JcdcFullscreenDialog',
  components: {
    VDialog,
    VContainer,
    VCard,
    VToolbar,
    VToolbarItems,
    VIcon,
    VBtn,
    VSpacer,
    VToolbarTitle,
  },
  props: {
    title: { type: String, required: true },
    open: { type: Boolean, required: false },
    print: { type: Boolean, default: false },
    color: { type: String, default: 'primary' },
  },
  data() {
    return {
      dialog: this.open,
    }
  },
  watch: {
    open() {
      this.dialog = this.open
    },
    dialog() {
      this.$emit('input', this.dialog)
    },
  },
})
